import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { useNavigate } from "react-router-dom";
import {
  MultiToteVerificationData,
  ScanningModal,
} from "../scanning-context/types";
import { ClosedFulfillmentGroupModal } from "./closed-fulfillment-group-modal";
import { DuplicateBarcodeModal } from "./duplicate-barcode-modal";
import { IncompleteVerificationModal } from "./incomplete-verification-modal";
import { MergedPackingSlipScannedModal } from "./merged-packing-slip-scanned-modal";
import { MultiToteVerificationModal } from "./multi-tote-verification-modal";
import { FulfillmentGroupSelectModal } from "./multiple-order-select-modal";
import {
  AttributesForSplitShipmentModal,
  AttributesForSplitShipmentModalData,
} from "./partially-fulfill-modal";
import { ToteOrderSelectionModal } from "./tote-order-selection-modal";
import { WrongBarcodeModal } from "./wrong-barcode-modal";

export function ScanningModals({
  doPartialFulfill,
  handleSelectFulfillmentGroup,
  handleNavigate,
  openModal,
  openModalData,
  onClose,
  relevantFulfillmentGroups,
}: {
  doPartialFulfill: (data: AttributesForSplitShipmentModalData) => void;
  handleSelectFulfillmentGroup: (group: FulfillmentGroupData) => void;
  handleNavigate: (path: string, options?: { resetScanned?: boolean }) => void;
  openModal?: ScanningModal;
  openModalData?: any;
  onClose: () => void;
  relevantFulfillmentGroups: FulfillmentGroupData[];
}) {
  const navigate = useNavigate();

  return (
    <>
      <FulfillmentGroupSelectModal
        identifier={openModalData}
        onClose={onClose}
        onSelect={handleSelectFulfillmentGroup}
        open={openModal === ScanningModal.FULFILLMENT_GROUP_SELECTION}
        relevantFulfillmentGroups={relevantFulfillmentGroups}
      />
      <ToteOrderSelectionModal
        isOpen={openModal === ScanningModal.TOTE_ORDER_SELECTION}
        onClose={onClose}
      />
      {openModal === ScanningModal.PARTIAL_FULFILL && (
        <AttributesForSplitShipmentModal
          onCloseRequested={onClose}
          onSubmit={doPartialFulfill}
        />
      )}
      <IncompleteVerificationModal
        onBack={() => {
          onClose();
        }}
        onContinue={() => {
          const path: string = openModalData;
          onClose();
          if (path) {
            handleNavigate(path, { resetScanned: true });
          }
        }}
        open={openModal === ScanningModal.INCOMPLETE_VERIFICATION}
      />
      <ClosedFulfillmentGroupModal
        onBack={() => {
          onClose();
          navigate("../");
        }}
        onContinue={onClose}
        open={openModal === ScanningModal.CLOSED_GROUP_WARNING}
      />
      {openModal === ScanningModal.WRONG_BARCODE && (
        <WrongBarcodeModal barcode={openModalData} onClose={onClose} />
      )}
      {openModal === ScanningModal.DUPLICATE_BARCODE && (
        <DuplicateBarcodeModal barcode={openModalData} onClose={onClose} />
      )}
      {openModal === ScanningModal.MERGED_PACKING_SLIP_SCANNED && (
        <MergedPackingSlipScannedModal
          fulfillmentGroupData={
            openModal === ScanningModal.MERGED_PACKING_SLIP_SCANNED
              ? (openModalData as FulfillmentGroupData)
              : undefined
          }
          onCancel={() => {
            onClose();
            handleNavigate("../scan", { resetScanned: true });
          }}
          onContinue={() => {
            onClose();
            handleNavigate(openModalData._id, { resetScanned: true });
          }}
          open={openModal === ScanningModal.MERGED_PACKING_SLIP_SCANNED}
        />
      )}
      {openModal === ScanningModal.MULTI_TOTE_VERIFICATION && (
        <MultiToteVerificationModal
          data={openModalData as MultiToteVerificationData}
          isOpen={openModal === ScanningModal.MULTI_TOTE_VERIFICATION}
          onClose={onClose}
          onContinue={() => {
            const data = openModalData as MultiToteVerificationData;
            onClose();
            handleNavigate(data.fulfillmentGroupId, { resetScanned: true });
          }}
        />
      )}
    </>
  );
}
